module.exports = __webpack_public_path__ + "img/camarones_apanados.c9afacbf.jpeg";